module.exports = __webpack_public_path__ + "static/vue/vue_mall/fonts/iconfont.c4a3ec90.ttf";